module.exports = __webpack_public_path__ + "img/result-contact-btn.f9881501.png";